import {useState,useRef,useEffect} from 'react';
import styles from './../../../css/pc/login/footer.module.scss';

const Footer_PC=(props)=>{

    try{
        const origin = location.origin ? location.origin : (location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''));
        return (
            <>
                {origin.indexOf('tradeking168')!= -1?<div className={styles.footer}>
                    <a href="https://beian.miit.gov.cn/#/Integrated/index" className={styles.icp} target="_blank">沪ICP备05058359号-3</a>
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402007463" className={styles.ga} target="_blank">沪公网安备31010402007463号</a>
                </div>:''}
            
            </>
        );
    }catch(e){
        console.log(e);
        return null;
    } 
};

export default Footer_PC;
